var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseIcon = function SvgPauseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 2.5a.833.833 0 0 0-.834.833v13.334c0 .46.373.833.833.833h3.334c.46 0 .833-.373.833-.833V3.333a.833.833 0 0 0-.833-.833zM11.666 2.5a.833.833 0 0 0-.833.833v13.334c0 .46.373.833.833.833h3.333c.46 0 .834-.373.834-.833V3.333a.833.833 0 0 0-.834-.833z"
  })));
};
export default SvgPauseIcon;